import { safeGetItem } from "@/helpers/safeLocalStorage";

export function getAuthorizationBearerStringFor(
  tokenKey: string
): string | null {
  const token = safeGetItem(tokenKey);

  if (
    !token ||
    token === "null" ||
    token === "undefined" ||
    token.trim() === ""
  ) {
    return null;
  }

  return `Bearer ${token}`;
}

export function getAuthHeaders(tokenKey = "access"): Record<string, string> {
  const authHeader = getAuthorizationBearerStringFor(tokenKey);
  if (!authHeader) {
    return {};
  }
  return { Authorization: authHeader };
}
